/** Created by azhou on 2019/2/18.*/
<template>
  <div>
    <div class="mt-2" v-if="brand">
      <public-title>轮播大图</public-title>
      <upload-image @fileChange="(imgs)=>{this.banner_pic = imgs;}"
                    :existImgs="banner_pic" :maxLength="15" editMode/>
    </div>
    <!--外观图图片-->
    <div class="mt-2" v-if="storeInfo.type!==6 && storeInfo.type != 8">
      <public-title>
        酒店{{storeInfo.type === 6 ? '图片' : '外观图'}}
      </public-title>
      <upload-image @fileChange="(imgs)=>{picImgs = imgs;}"
                  :existImgs="picImgs" :maxLength="20" editMode/>
    </div>
    <div class="prompt">
      <p class="text">提示：第一张图片为主图可拖动调整</p>
    </div>
    <!--大堂图片-->
    <div class="mt-2" v-if="storeInfo.type!==6 && storeInfo.type != 8">
      <public-title>
        酒店{{storeInfo.type === 6 ? '图片' : '大堂图'}}
      </public-title>
      <upload-image @fileChange="(imgs)=>{lobbyImgs = imgs;}"
                  :existImgs="lobbyImgs" :maxLength="20" editMode/>
    </div>
    <!--公共图片-->
    <div class="mt-2" v-if="storeInfo.type!==6 && storeInfo.type != 8">
      <public-title>
        酒店公区图
      </public-title>
      <upload-image @fileChange="(imgs)=>{commonImgs = imgs;}"
                    :existImgs="commonImgs" :maxLength="20" editMode/>
    </div>
    <!--餐厅图片-->
    <div class="mt-2" v-if="storeInfo.type!==6 && storeInfo.type != 8">
      <public-title>
        酒店餐厅图
      </public-title>
      <upload-image @fileChange="(imgs)=>{eateryImgs = imgs;}"
                    :existImgs="eateryImgs" :maxLength="20" editMode/>
    </div>
    <!--休闲图片-->
    <div class="mt-2" v-if="storeInfo.type!==6 && storeInfo.type != 8">
      <public-title>
        酒店休闲康乐图
      </public-title>
      <upload-image @fileChange="(imgs)=>{restImgs = imgs;}"
                    :existImgs="restImgs" :maxLength="20" editMode/>
    </div>
    <!--其他图片-->
    <div class="mt-2" v-if="storeInfo.type!==6 && storeInfo.type != 8">
      <public-title>
        酒店其他配套图
      </public-title>
      <upload-image @fileChange="(imgs)=>{healthImags = imgs;}"
                    :existImgs="healthImags" :maxLength="20" editMode/>
    </div>
    <el-button @click="saveImages" class="mt-2 w-25 btn-login">保存相册</el-button>
    <p class="h5 text-muted mt-2">
      <i class="iconfont icon-xuzhixianxiao mr-1 h5"></i>
      图片格式: GIF、JPG、JPEG、PNG，文件大小超过2M将自动压缩上传
    </p>
  </div>
</template>

<script>
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    name: 'StorePhotos',
    computed: {
      ...mapState(['StoreBasicInfo']),
      ...mapGetters(['storeInfo','brand'])
    },
    data () {
      return {
        banner_pic: [],              // 品牌馆轮播大图
        picImgs: [],                 //酒店外观图
        lobbyImgs: [],               //酒店大堂图片
        commonImgs: [],              //酒店公共图片
        eateryImgs: [],              //酒店餐厅图片
        restImgs:[],                 //酒店休闲图片
        healthImags:[],              //酒店其他图片
        avatar:'',                   //门店LOGO
      }
    },
    watch: {
      StoreBasicInfo () {
        this.initPhotos()
      }
    },
    created () { this.initPhotos() },
    methods: {
      ...mapActions(['saveStoreInfo']),
      /*初始化门店相册*/
      initPhotos () {
        // 定义图片字段与目标变量的映射关系
        const imgMappings = [
          { source: 'pic', target: 'picImgs' },
          { source: 'pic_lobby', target: 'lobbyImgs' },
          { source: 'pic_common', target: 'commonImgs' },
          { source: 'pic_eatery', target: 'eateryImgs' },
          { source: 'pic_rest', target: 'restImgs' },
          { source: 'pic_other', target: 'healthImags' }
        ];
        // 循环处理所有图片字段
        imgMappings.forEach(({ source, target }) => {
          this[target] = this.$verify.stitch(this.StoreBasicInfo[source]).map(v =>  v);
        });
      },
      /*提交前验证*/
      validateFun() {
        switch (this.storeInfo.type) {
          case 3:
            case 4:
            // if (this.picImgs.length <= 0) return {code:false,msg:'外观图至少上传一张'}
            // if (this.lobbyImgs.length <= 0) return {code:false,msg:'酒店大堂至少上传一张'}
            // if (this.commonImgs.length <= 0) return {code:false,msg:'酒店公共至少上传一张'}
            break;
          case 5:
          case 6:
            if (this.FacadeImgs.length <= 0) return {code:false,msg:'外观图至少上传一张'}
            break;
          case 8:
            if (this.banner_pic == '') return {code:false,msg:'轮播大图至少上传一张'}
            if (this.FacadeImgs.length <= 0) return {code:false,msg:'外观图至少上传一张'}
            break;
        }
        return {code:true,msg:'验证通过'}
      },
      /*保存相册信息*/
      saveImages () {
        // 品牌馆权限
        //if (!this.$GFUN.powerIsInArray([95,363,428,99,234,155,271,370])) { this._alert('您没有相关权限！',null,'error'); return; }
        let result = this.validateFun();
        if (result.code) {
          this._confirm('确定提交保存么？', async () => {
            //上传图片组
            let info = {}
            info.pic = await UploadImages(this.picImgs,true)                     //外观图片
            info.pic_lobby  = await UploadImages(this.lobbyImgs,true)            //大堂图片
            info.pic_common = await UploadImages(this.commonImgs,true)           //公共图片
            info.pic_eatery	 = await UploadImages(this.eateryImgs,true)          //餐厅图片
            info.pic_rest	 = await UploadImages(this.restImgs,true)              //休闲图片
            info.pic_other = await UploadImages(this.healthImags,true)          //其他图片
            //editAlbum
            this.$emit('saveInfo',info)
          })
        } else this._alert(result.msg,null,'error');
      }
    }
  }
</script>
<style lang="css" scoped>
.prompt{
  text-align: center;

}
.text{
  text-align: left;
  color: #999;
  font-size: 12px;
}
</style>